import React, { useState } from 'react';
import './SuporteModule.css';

interface Chamado {
  id: number;
  titulo: string;
  descricao: string;
  status: 'Aberto' | 'Fechado';
  criadoEm: string;
}

const SuporteModule: React.FC = () => {
  const [chamados, setChamados] = useState<Chamado[]>([]);
  const [form, setForm] = useState({ titulo: '', descricao: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.titulo.trim()) return;
    const novoChamado: Chamado = {
      id: Date.now(),
      titulo: form.titulo,
      descricao: form.descricao,
      status: 'Aberto',
      criadoEm: new Date().toLocaleString(),
    };
    setChamados([novoChamado, ...chamados]);
    setForm({ titulo: '', descricao: '' });
  };

  const fecharChamado = (id: number) => {
    setChamados(chamados.map(c => c.id === id ? { ...c, status: 'Fechado' } : c));
  };

  return (
    <div className="suporte-module">
      <h2>Abertura de Chamados</h2>
      <form onSubmit={handleSubmit} className="chamado-form">
        <input
          name="titulo"
          value={form.titulo}
          onChange={handleChange}
          placeholder="Título do chamado"
          required
        />
        <textarea
          name="descricao"
          value={form.descricao}
          onChange={handleChange}
          placeholder="Descreva o problema"
          rows={3}
        />
        <button type="submit">Abrir chamado</button>
      </form>
      <h3>Chamados abertos</h3>
      <ul className="chamados-list">
        {chamados.length === 0 && <li>Nenhum chamado aberto.</li>}
        {chamados.map(chamado => (
          <li key={chamado.id} className={chamado.status === 'Fechado' ? 'fechado' : 'aberto'}>
            <strong>{chamado.titulo}</strong> <span>({chamado.status})</span>
            <div>{chamado.descricao}</div>
            <small>{chamado.criadoEm}</small>
            {chamado.status === 'Aberto' && (
              <button onClick={() => fecharChamado(chamado.id)}>Fechar chamado</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};   
    
    
export default () => (
  <div>
    <SuporteModule />
  </div>
);